import React from "react";
import { Switch, Route } from "react-router-dom";
import { Layout } from "antd";
import BookingPage from "./BookingPage";
import CartSummaryPage from "./CartSummaryPage";
import CartAddressPage from "./CartAddressPage";
import CartPaymentMethodPage from "./CartPaymentMethodPage";
import PurchaseOrderPage from "./PurchaseOrderPage";
import OrderSuccessPage from "./OrderSuccessPage";
import OrderDetailsPage from "./OrderDetailsPage";
import OrderHistoryPage from "./OrderHistoryPage";
import ProfilePage from "./ProfilePage";
import CompanyProfilePage from "./CompanyProfilePage";
import AddressManagementPage from "./AddressManagementPage";
import NotFoundPage from "../NotFoundPage";
import ConsumerTopMenu from "../../../components/ConsumerTopMenu";
import routes from "../../../../routes";
import "./style.css";
import PlaceOrder from "./PlaceOrder";
import AnalyticsDashboard from "./AnalyticsDashboard";

const { Header, Content } = Layout;

const ConsumerApp = () => {
  return (
    <Layout>
      <Header style={{ background: "#eff3f7" }}>
        <ConsumerTopMenu />
      </Header>
      <Content className="mainContainer">
        <Switch>
          <Route exact path={routes.dashboard} component={AnalyticsDashboard} />
          <Route exact path={routes.placeOrder} component={PlaceOrder} />
          <Route exact path={routes.account.profile} component={ProfilePage} />
          <Route
            exact
            path={routes.account.orders}
            component={OrderHistoryPage}
          />
          <Route
            exact
            path={routes.account.company}
            component={CompanyProfilePage}
          />
          <Route
            exact
            path={routes.account.address}
            component={AddressManagementPage}
          />
          <Route exact path={routes.booking} component={BookingPage} />
          <Route exact path={routes.cart} component={CartSummaryPage} />
          <Route exact path={routes.cartAddress} component={CartAddressPage} />
          <Route
            exact
            path={routes.paymentMethod}
            component={CartPaymentMethodPage}
          />
          <Route
            exact
            path={routes.purchaseOrder}
            component={PurchaseOrderPage}
          />
          <Route
            exact
            path={routes.orders.success}
            component={OrderSuccessPage}
          />
          <Route path={routes.orders.details} component={OrderDetailsPage} />

          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Content>
    </Layout>
  );
};

export default ConsumerApp;
